import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Loader, PageHeading } from "../../common/components";
import './notifications.css'
import { icons } from "../../assets";
import { receivedError, requestSent, responseRecived } from "../../redux/actions/utilsActions";
import { getNotificationsApi } from "../../api/notifications";
import { useSearchParams } from "react-router-dom";
import Pagination from "rc-pagination";
import { convertDateFormat } from "../../utils/dateUtils";

const DownloadCSVFiles = () => {
  // Hooks //
  const dispatch = useDispatch()
  const { loading } = useSelector((state) => state.utils);
  const { userToken } = useSelector((state) => state.user);

  const [notifications, setNotifications] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);


  const [searchParams, setSearchParams] = useSearchParams({ page: 1 })

  useEffect(() => {
    getNotifications(Number(searchParams.get("page")));
  }, []);

  const getNotifications = async (page) => {
    try {
      dispatch(requestSent());
      const data = await getNotificationsApi(userToken, page);
      setNotifications(data.data.rows);
      setTotalCount(data.data.count);
      dispatch(responseRecived())
    } catch (error) {
      dispatch(receivedError(error))
    }
  }

  const updatePageHandler = (p) => {
    setSearchParams({ page: p });
    setCurrentPage(p);
    getNotifications(p)
  };

  if (loading) {
    return <Loader />
  }

  return (
    <div id="induction">
      <PageHeading title={"Notifications"} />

      {
        !notifications.length ? <p style={{ textAlign: 'center' }}>No Notifications Recived yet</p> :
          <div className="right-sec_cont">
            {
              notifications.map(n => {
                return <div className="notification_card" key={n.id}>
                  <img src={icons.notification} alt="" width="20" />
                  <p>{n.title}</p>
                  <p>{convertDateFormat(n.createdAt, 'YYYY-MM-DD HH:mm:ss', 'DD/MM/YYYY HH:mm:ss')}</p>
                </div>
              })
            }

            <div className="pagination_cont">
              <Pagination
                pageSize={10}
                onChange={updatePageHandler}
                current={currentPage}
                total={totalCount}
              />
            </div>
          </div>
      }
    </div>
  );
};

export default DownloadCSVFiles;
